document.querySelectorAll('.js-overlay-link').forEach(($link) => {
  const $target = $link.closest(`.${$link.getAttribute('data-overlay-target')}`);
  let down;
  let up;

  if ($target) {
    $target.addEventListener('mouseover', () => {
      $link.classList.add('active-overlay');
      $target.style.cursor = 'pointer';
    });

    $target.addEventListener('mouseout', () => {
      $link.classList.remove('active-overlay');
      $target.removeAttribute('style');
    });

    // prevent click while user-selection
    $target.addEventListener('mousedown', () => {
      down = new Date();
    });

    $target.addEventListener('mouseup', () => {
      up = new Date();

      if ((up - down) < 200) {
        $link.click();
      }
    });
  }
});
